import React, { useState } from 'react'
import ResactlyTab from '../../../../components/ResactlyTab'
import EaterLeaderboard from './EaterLeaderboard'
// import InfluencerLeaderboard from './InfluencerLeaderboard'
import PointTransaction from './PointTransaction'
import { useAppSelector } from '../../../../store'
import { selectIsInfluencer } from '../../../../store/influencer/contentCreator'

interface LeaderboardTabProps {
  propName?: string
}

const LeaderboardTab: React.FC<LeaderboardTabProps> = ({ propName }) => {
  const IsInfluencer = useAppSelector(selectIsInfluencer)
  const [changeTab] = useState(0)
  return (
    <ResactlyTab
      list={tabList.filter(
        (item) => !(!IsInfluencer && item.value === 'influencer-leaderboard'),
      )}
      tabComponent={tabComponentList}
      align="start"
      changeTab={changeTab}
    />
  )
}

export default LeaderboardTab

const tabComponentList = [
  // <InfluencerLeaderboard key="influencer-leaderboard" />,
  <EaterLeaderboard key="eater-leaderboard" />,
  <PointTransaction key="point-transaction" />,
]

const tabList = [
  // {
  //   label: 'Influencer Leaderboard',
  //   value: 'influencer-leaderboard',
  // },
  {
    label: 'Points',
    value: 'eater-leaderboard',
  },
  {
    label: 'Point Transactions',
    value: 'point-transaction',
  },
]
